// import imageOne from "../../images/v2/media/media-conf1.jpg";
// import imageTwo from "../../images/v2/media/media-conf2.jpg";
// import imageThree from "../../images/v2/media/media-conf3.jpg";
// import imageFour from "../../images/v2/media/media-conf4.jpg";
// import imageFive from "../../images/v2/media/media-conf5.jpg";

import blogImg1 from "../../images/v2/media/blog/blogImg1.jpg";
import blogImg2 from "../../images/v2/media/blog/blogImg2.jpeg";
import blogImg3 from "../../images/v2/media/blog/blogImg3.jpeg";
import blogImg4 from "../../images/v2/media/blog/blogImg4.jpg";
import blogImg5 from "../../images/v2/media/blog/blogImg5.jpg";

import videoImg2 from "../../images/v2/hero-img-community-2.jpg";
import videoImg1 from "../../images/v2/donatePng.jpg";

// import sag1 from "../../images/v2/media/images/sag1.jpg";
import sag2 from "../../images/v2/media/images/sag2.jpg";
import sag3 from "../../images/v2/media/images/sag3.jpg";
import sag4 from "../../images/v2/media/images/sag4.jpg";
import sag5 from "../../images/v2/media/images/sag5.jpg";
import sag6 from "../../images/v2/media/images/sag6.jpg";
import sag7 from "../../images/v2/media/images/sag7.jpg";
import sag8 from "../../images/v2/media/images/sag8.jpg";
import sag9 from "../../images/v2/media/images/sag9.jpg";
import sag10 from "../../images/v2/media/images/sag10.jpg";
import sag11 from "../../images/v2/media/images/sag11.jpg";
import sag12 from "../../images/v2/media/images/sag12.jpg";
import sag13 from "../../images/v2/media/images/sag13.jpg";
import { ghcConnectMedia, sagMedia, sdlMedia, summitMedia } from "./MediaCDN";
const sag1 =
  "https://cdn.jsdelivr.net/gh/free-whiteboard-online/Free-Erasorio-Alternative-for-Collaborative-Design@ace6b1295e32298b63841372f7c5c00918a6f784/uploads/2025-12-05T09-12-12-558Z-yauzsay4t.jpg";

export const mediaContent = [
  {
    title: "She Code Africa Stem A Girl Kaduna",
    description: "Kaduna State, Nigeria Edition.",
    coverImages: [sag1, sag2, sag3, sag4],
    date: "11/07/2025",
    content: [
      {
        id: 101,
        title: "She Code Africa Stem A Girl Kaduna",
        images: [
          sag1,
          sag2,
          sag3,
          sag4,
          sag5,
          sag6,
          sag7,
          sag8,
          sag9,
          sag10,
          sag11,
          sag12,
          sag13,
          sagMedia.sag14,
          sagMedia.sag15,
          sagMedia.sag16,
          sagMedia.sag17,
          sagMedia.sag18,
          sagMedia.sag19,
          sagMedia.sag20,
          sagMedia.sag21,
        ],
      },
    ],
  },

  {
    title: "She Code Africa Summit 2024 Edition",
    description: "2024 Edition, Lagos Nigeria",
    coverImages: [
      summitMedia.summit1,
      summitMedia.summit2,
      summitMedia.summit3,
      summitMedia.summit4,
    ],
    date: "13/01/2025",
    content: [
      {
        id: 101,
        title: "She Code Africa Summit 2024 Edition",
        images: [
          summitMedia.summit1,
          summitMedia.summit2,
          summitMedia.summit3,
          summitMedia.summit4,
          summitMedia.summit5,
          summitMedia.summit6,
          summitMedia.summit7,
          summitMedia.summit8,
          summitMedia.summit9,
          summitMedia.summit10,
          summitMedia.summit11,
          summitMedia.summit12,
          summitMedia.summit13,
          summitMedia.summit14,
          summitMedia.summit15,
          summitMedia.summit16,
          summitMedia.summit17,
          summitMedia.summit18,
          summitMedia.summit19,
          summitMedia.summit20,
          summitMedia.summit21,
        ],
      },
    ],
  },

  {
    title: "She Code Africa Digital Literacy Program 2025",
    description: "Digital Literacy, 2025 Edition.",
    coverImages: [sdlMedia.sdl1, sdlMedia.sdl2, sdlMedia.sdl3, sdlMedia.sdl4],
    date: "11/07/2025",
    content: [
      {
        id: 101,
        title: "She Code Africa Digital Literacy Program 2025",
        images: [
          sdlMedia.sdl1,
          sdlMedia.sdl2,
          sdlMedia.sdl3,
          sdlMedia.sdl4,
          sdlMedia.sdl5,
          sdlMedia.sdl6,
          sdlMedia.sdl7,
          sdlMedia.sdl8,
          sdlMedia.sdl9,
          sdlMedia.sdl10,
          sdlMedia.sdl11,
          sdlMedia.sdl12,
          sdlMedia.sdl13,
          sdlMedia.sdl14,
          sdlMedia.sdl15,
          sdlMedia.sdl16,
          sdlMedia.sdl17,
          sdlMedia.sdl18,
          sdlMedia.sdl19,
          sdlMedia.sdl20,
          sdlMedia.sdl21,
        ],
      },
    ],
  },
  {
    title: "She Code Africa Ghana Community Connect ",
    description: "Community Connect, Ghana Edition.",
    coverImages: [
      ghcConnectMedia.ghc6,
      ghcConnectMedia.ghc2,
      ghcConnectMedia.ghc3,
      ghcConnectMedia.ghc4,
    ],
    date: "11/07/2025",
    content: [
      {
        id: 101,
        title: "She Code Africa Ghana Community Connect",
        images: [
          ghcConnectMedia.ghc1,
          ghcConnectMedia.ghc2,
          ghcConnectMedia.ghc3,
          ghcConnectMedia.ghc4,
          ghcConnectMedia.ghc5,
          ghcConnectMedia.ghc6,
          ghcConnectMedia.ghc7,
          ghcConnectMedia.ghc8,
          ghcConnectMedia.ghc9,
          ghcConnectMedia.ghc10,
          ghcConnectMedia.ghc11,
          ghcConnectMedia.ghc12,
          ghcConnectMedia.ghc13,
          ghcConnectMedia.ghc14,
          ghcConnectMedia.ghc15,
          ghcConnectMedia.ghc16,
          ghcConnectMedia.ghc17,
          ghcConnectMedia.ghc18,
          ghcConnectMedia.ghc19,
          ghcConnectMedia.ghc20,
          ghcConnectMedia.ghc21,
        ],
      },
    ],
  },

  // {
  //   id: 2,
  //   title: "SCA Girls Outreach - Image Gallery",
  //   coverImages: [],
  //   description: "",
  //   date: "",
  //   content: [
  //     {
  //       id: 201,
  //       title: "SCA Girls Outreach (Kano)",
  //       images: [
  //         imageOne,
  //         imageTwo,
  //         imageThree,
  //         imageThree,
  //         imageFour,
  //         imageFive,
  //         imageOne,
  //         imageTwo,
  //         imageThree,
  //         imageThree,
  //         imageFour,
  //         imageFive,
  //         imageOne,
  //         imageTwo,
  //         imageThree,
  //         imageThree,
  //         imageFour,
  //         imageFive,
  //       ],
  //     },
  //     {
  //       id: 202,
  //       title: "SCA Girls Outreach (Ibadan)",
  //       images: [
  //         imageOne,
  //         imageTwo,
  //         imageThree,
  //         imageThree,
  //         imageFour,
  //         imageFive,
  //         imageOne,
  //         imageTwo,
  //         imageThree,
  //         imageThree,
  //         imageFour,
  //         imageFive,
  //         imageOne,
  //         imageTwo,
  //         imageThree,
  //         imageThree,
  //         imageFour,
  //         imageFive,
  //       ],
  //     },
  //   ],
  // },
];

export const videoContents = [
  {
    title: "She Code Africa STEM A Girl Initiative",
    type: "She Code Africa Initiatives",
    description: "Kaduna State, Nigeria Edition",
    author: "She Code Africa",
    dateCreated: "11/07/2025",
    coverImage: videoImg1,
    url: "https://www.youtube.com/embed/YMLyOPcyEnA?si=lKsl2vcolsLbnYSK",
  },
  {
    title: "She Code Africa Annual Summit",
    type: "She Code Africa Events",
    description: "2024 Edition, Lagos Nigeria ",
    author: "She Code Africa",
    dateCreated: "13/01/2025",
    coverImage: videoImg2,
    url: "https://www.youtube.com/embed/j_oGekQqj34?si=sJlL-7QqsNQ1JSB1",
  },
];

export const blogContent = [
  {
    title: "She Code Africa Digital Literacy Program Takes Off",
    type: "She Code Africa Initiatives",
    description: "First Stop, Oyo State Nigeria.",
    author: "Winner Bright",
    dateCreated: "18/11/2025",
    coverImage: blogImg1,
    url: "https://www.linkedin.com/pulse/she-code-africa-digital-literacy-program-takes-off-first-azbtf/?trackingId=SI17pHSFSrqWjpg6q2PIKw%3D%3D",
  },
  {
    title: "I want to Dive into Tech but I’m confused",
    type: "Career Development ",
    description: "But I’m confused",
    author: "Lois Choji",
    dateCreated: "01/01/2023",
    coverImage: blogImg2,
    url: "https://medium.com/shecodeafrica/i-want-to-dive-into-tech-but-im-confused-756935b7e185",
  },
  {
    title: "What NOT to do While Applying for a Role in Tech",
    type: "Career Development",
    description: "Job-hunting is not easy; that’s true",
    author: "Olamide Makinde",
    dateCreated: "01/03/2023",
    coverImage: blogImg3,
    url: "https://medium.com/shecodeafrica/what-not-to-do-while-applying-for-a-role-in-tech-61459e0a25c4",
  },
  {
    title: "She Code Africa Joins 2025 HP Digital Equity Accelerator!",
    type: "She Code Africa Updates",
    description: "A global initiative by HP Inc. and the HP Foundation",
    author: "Winner Bright",
    dateCreated: "29/04/2025",
    coverImage: blogImg4,
    url: "https://medium.com/shecodeafrica/she-code-africa-joins-2025-hp-digital-equity-accelerator-fc61e7a53671",
  },
  {
    title: "Why We Need More Women in Tech",
    type: "Tech Insights",
    description: "The Way Forward",
    author: "Hafsah Emekoma",
    dateCreated: "13/08/2021",
    coverImage: blogImg5,
    url: "https://medium.com/shecodeafrica/why-we-need-more-women-in-tech-a4f677d0ae59",
  },
  {
    title:
      "She Code Africa Recognized as an Impact Award Winner by Zendesk Foundation’s Tech for Good Program",
    type: "She Code Africa Updates",
    description: "Zendesk Foundation’s Tech for Good Program",
    author: "Winner Bright",
    dateCreated: "12/11/2025",
    coverImage: blogImg5,
    url: "https://medium.com/shecodeafrica/she-code-africa-recognized-as-an-impact-award-winner-by-zendesk-foundations-tech-for-good-program-67d2dd33bc7b",
  },
];
